import { NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MobileBottomNav } from "@/components/layout/MobileBottomNav";
import { Truck, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/Logo";

export function DashboardShell({ nav, children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-xd-bg text-white flex">
      {/* Sidebar (desktop) */}
      <aside className="hidden lg:flex flex-col w-64 shrink-0 border-r border-xd-border bg-xd-paper sticky top-0 h-screen">
        <div className="flex items-center px-5 h-16 border-b border-xd-border">
          <LogoMark to="/" />
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`side-nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-xd-orange/15 text-xd-orange" : "text-xd-muted hover:text-white hover:bg-xd-surface"}`}>
              <Icon size={18} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-xd-border">
          <div className="px-3 py-2 mb-2">
            <p className="text-sm font-semibold truncate">{user?.name}</p>
            <p className="text-xs text-xd-dim capitalize">{user?.role}</p>
          </div>
          <Button data-testid="dash-logout-btn" variant="outline" className="w-full border-xd-border text-white hover:bg-xd-surface" onClick={() => { logout(); navigate("/"); }}>
            <LogOut size={16} className="mr-2" /> Logout
          </Button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0 pb-20 lg:pb-0">
        <header className="lg:hidden sticky top-0 z-40 bg-black/70 backdrop-blur-xl border-b border-white/10 h-14 flex items-center justify-between px-4">
          <LogoMark to="/" size="sm" />
          <span className="text-xs text-xd-muted capitalize">{user?.role}</span>
        </header>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
          {title && <h1 className="font-heading text-3xl font-black tracking-tight mb-6">{title}</h1>}
          {children}
        </div>
      </div>

      {user?.role === "carrier" && <MobileBottomNav />}
    </div>
  );
}
